"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestParamsDefaultAdder = exports.BookingURLDecoder = exports.BookingURLDecodeError = void 0;
const date_fns_1 = require("date-fns");
const lodash_1 = require("lodash");
const dateCoder_1 = require("./dateCoder");
require("./extensions/string");
const schedulingFormulaParamCoder_1 = require("./schedulingFormulaParamCoder");
class BookingURLDecodeError extends Error {
}
exports.BookingURLDecodeError = BookingURLDecodeError;
class BookingURLDecoder {
    static decode(url) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const result = url.match(this.REGEX);
        if (result.groups === undefined ||
            result.groups.userId.isEmpty() ||
            result.groups.lengthMin.isEmpty()) {
            throw new BookingURLDecodeError(`Fail to decode url ${url}`);
        }
        const { userId, lengthMin, queryParams } = result.groups;
        const { formula, start, end, buffer, booking_calendars, loc, booker, proxy, room, booking_id, allow_reschedule, allow_cancel } = this.decodeParams(queryParams);
        return {
            userId,
            lengthMin: parseInt(lengthMin),
            formula: schedulingFormulaParamCoder_1.SchedulingFormulaParamDecoder.decode(formula),
            // デフォルトは翌日から1ヶ月
            start: start ? (0, dateCoder_1.parseFullDate)(start) : undefined,
            end: end ? (0, date_fns_1.endOfDay)((0, dateCoder_1.parseFullDate)(end)) : undefined,
            buffer: buffer ? parseInt(buffer) : undefined,
            bookingCalendarIds: booking_calendars
                ? this.decodeCalendarParam(booking_calendars)
                : undefined,
            location: loc,
            booker,
            proxy,
            room: this.decodeRoomParam(room),
            bookingId: booking_id,
            allowCancel: allow_cancel === '1' || undefined,
            allowReschedule: allow_reschedule === '1' || undefined
        };
    }
    static decodeWithDefault(url) {
        const requestParams = this.decode(url);
        return RequestParamsDefaultAdder.addDefault(requestParams);
    }
    static decodeCalendarParam(calendar) {
        return (0, lodash_1.uniq)(calendar.split('&')).map((c) => parseInt(c));
    }
    static decodeRoomParam(room) {
        return room ? decodeURIComponent(room).split('|') : undefined;
    }
    static decodeParams(rawParams) {
        if ((0, lodash_1.isUndefined)(rawParams))
            return {};
        const params = rawParams.split('+');
        const decodedParams = {};
        params.forEach((p) => {
            const [key, value] = p.split('=');
            decodedParams[key] = value;
        });
        return decodedParams;
    }
}
exports.BookingURLDecoder = BookingURLDecoder;
// NOTE: 正規表現の検証にはこれが便利
// https://regex101.com/
// ex) /kazuwombat/90?formula=hanako&taro+start=2020-10-20&end=2020-10-27
BookingURLDecoder.REGEX = /\/(?<userId>.*)\/(?<lengthMin>[0-9]*)\+?(?<queryParams>([^?]*))?(\?(?<urlQuery>.*))?/;
class RequestParamsDefaultAdder {
    static addDefault(params) {
        const bookingParams = Object.assign({}, params);
        if ((0, lodash_1.isUndefined)(bookingParams.buffer)) {
            bookingParams.buffer = this.defaults.buffer;
        }
        if ((0, lodash_1.isUndefined)(bookingParams.start)) {
            bookingParams.start = this.defaults.start;
            bookingParams.end = this.defaults.end;
        }
        if ((0, lodash_1.isUndefined)(bookingParams.bookingCalendarIds) ||
            (0, lodash_1.isEmpty)(bookingParams.bookingCalendarIds)) {
            bookingParams.bookingCalendarIds = this.defaults.bookingCalendarIds;
        }
        return bookingParams;
    }
}
exports.RequestParamsDefaultAdder = RequestParamsDefaultAdder;
RequestParamsDefaultAdder.defaults = {
    buffer: 0,
    start: new Date(),
    end: (0, date_fns_1.endOfDay)((0, date_fns_1.addMonths)(new Date(), 1)),
    bookingCalendarIds: [0]
};
//# sourceMappingURL=bookingURLDecoder.js.map